import { toast } from "@appsmith/ads";

import { buildCommandRunToast } from "./buildCommandRunToast";
import type { AnvilCommand } from "./types";

/**
 * Shows the confirmation toast for a run command via the shared ADS toast
 * service (reused, not reimplemented). No-op for commands that opt out.
 */
export function showCommandRunToast(command: AnvilCommand): void {
  const descriptor = buildCommandRunToast(command);

  if (descriptor) {
    toast.show(descriptor.text, { kind: descriptor.kind });
  }
}
